let _this, video, canvas, context, mediaStreamTrack,videoWidth,videoHeight;

$(function () {
  $(document).on('change', '#upload-face-file', function (e) {
    let acceptTypeArr = ["image/png","image/x-png","image/jpeg"];
    let file = $(this)[0].files[0];
    if (file && file.size > 20480 && file.size <= _this.faceSize * 1048576 && acceptTypeArr.indexOf(file.type) > -1) {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = window.URL.createObjectURL($(this)[0].files[0]);
      img.onload = function(e){ 
        if (this.width >= 150 && this.width <= 4096 && this.height >= 150 && this.height <= 4096) {
          let reader = new FileReader();
          reader.onload = function(e) {
            _this.cameraPath = e.target.result;
            _this.cameraModal = true;//打开剪切弹窗
            _this.cropperModel = true;
            $('#user-face').cropper('replace',e.target.result,false );
            _this.$nextTick(function () {
              _this.initCropper();
            })
          };
          _this.fileName = file.name; //加入时间戳避免重复上传同一张图片时，名称相同页面刷新失败的问题
          reader.readAsDataURL(file);
        }else{
          $('#upload-face-file').val('');
          _this.messageNotice('error', _this.common.errMsg);
        }
      }    
    }else{
      $('#upload-face-file').val('');
      _this.messageNotice('error', _this.common.errMsg);
    }
  });
});

export default {
  name: "camera-and-upload",
  props:['userInfo','userType'],
  data(){
    return{
      isCamera:false,//是否是拍照
      cameraModal:false,//是否打开弹窗
      cropperModel:false,//是否上传相关显示
      cameraPath:'',
      photoFlag:false,
      closable:false,
      fileName:'visitorFace',
      faceSize:window.g.uploadFaceSize,
      necessaryFace:false,/*必填*/
      showFace:true,/*显示*/
    }
  },
  mounted(){
    _this = this;
    this.initInfo();
  },
  watch:{
    'cameraModal':{
      handler(nv, ov){
        if(nv === false){
          mediaStreamTrack && mediaStreamTrack.stop();
          $('#upload-face-file').val('');
        }
      }
    },
  },
  methods:{
    initInfo:function () {
      switch (_this.userType){
        case 1:
          _this.necessaryFace = _this.ApiService.userFaceRequired.Visitor;
          _this.showFace = _this.ApiService.userFormField.Visitor['Face Photo'];
          break;
        case 2:
          _this.necessaryFace = _this.ApiService.userFaceRequired.Vendor;
          _this.showFace = _this.ApiService.userFormField.Vendor['Face Photo'];
          break;
      }
    },
    //选择上传人脸方式
    selectUploadMth:function (e) {
      if($(e.target).hasClass('add-user-photo-bg') || $(e.target).hasClass('user-face') || $(e.target).hasClass('replace-btn')){
        $('.upload-face-way').fadeIn().css({left:e.offsetX + 3 + 'px', bottom: '', top: $(e)[0].offsetY});
        $('.pro-upload-face-method').fadeOut();
      }
    },
    //选择上传方式
    uploadImg:function(e){
      e.stopPropagation();
      _this.isCamera = false;
      $('.upload-face-way').fadeOut();
      $('#upload-face-file').click();
    },
    //录入人脸
    camera:function () {
      this.cameraModal = true;
      this.cropperModel = false;
      this.isCamera = true;
      $('.upload-face-way').fadeOut();
      this.$nextTick(()=>{
        _this.init();
      })
    },

    //点击确认按钮拍照
    trickImg:function () {
      //绘制画面
      context.drawImage(video, 0, 0, videoWidth, videoHeight);
      mediaStreamTrack.stop();
      $('#user-video-box').hide();
      _this.cropperModel = true;
      _this.cameraPath = canvas.toDataURL("image/jpeg");
      $('#user-face').cropper('replace',canvas.toDataURL("image/jpeg"),false );
      _this.$nextTick(()=>{
        _this.initCropper();
      });
      _this.fileName = 'face' + new Date(_this.moment()).getTime();
    },

    cropperImg:function (type) {
      let cas = $('#user-face').cropper('getCroppedCanvas');
      let base64url = cas.toDataURL('image/jpeg');
      //见图片上传到文件服务器
      _this.cameraModal = false;
	    _this.userInfo.faceFileBase64 = base64url.split(',')[1];
      _this.$set(_this.userInfo,"faceFlag",false);
    },
    //删除头像
    deleteFacePhoto:function(){
      _this.userInfo.faceFileBase64 = '';
      _this.$set(_this.userInfo,"faceFlag",false);
      _this.$forceUpdate();
    },
    //重新选取图片
    RemakeUploadFile:function(){
      $('#upload-face-file').val('');
      $('#upload-face-file').click();
    },

    initCropper:function () {
      $('#user-face').cropper({
        aspectRatio: 3 / 4,
        viewMode:1,
        preview:".small",
        background:false,
        autoCropArea:1
      });
    },

    rotateLeft:function () {
      $('#user-face').cropper('rotate', 90);
    },

    rotateRight:function () {
      $('#user-face').cropper('rotate', -90);
    },

    plus:function () {
      $('#user-face').cropper('zoom', 0.1);
    },

    mini:function () {
      $('#user-face').cropper('zoom', -0.1);
    },

    rotateReset:function () {
      $('#user-face').cropper('reset');
    },

    //剪切摄像拍照头像
    init:function () {
      $('#user-video-box').show();
      //访问用户媒体设备的兼容方法
      function getUserMedia(constrains,success,error){
        if(navigator.mediaDevices.getUserMedia){
          //最新标准API
          navigator.mediaDevices.getUserMedia(constrains).then(success).catch(error);
        } else if (navigator.webkitGetUserMedia){
          //webkit内核浏览器
          navigator.webkitGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.mozGetUserMedia){
          //Firefox浏览器
          navagator.mozGetUserMedia(constrains).then(success).catch(error);
        } else if (navigator.getUserMedia){
          //旧版API
          navigator.getUserMedia(constrains).then(success).catch(error);
        }
      }

      video = document.getElementById("user-video-box");
      canvas = document.getElementById("user-canvas-box");
      canvas.style.width = 720 + "px";
      canvas.style.height = 420 + "px";
      context = canvas.getContext("2d");

      //成功的回调函数
      function success(stream){
        //兼容webkit内核浏览器
        let CompatibleURL = window.URL || window.webkitURL;
        //将视频流设置为video元素的源
        mediaStreamTrack = stream.getTracks()[0];
        video.srcObject = stream;
        video.addEventListener('canplay', function() {
          videoWidth = this.videoWidth;
          videoHeight = this.videoHeight;
          canvas.width = videoWidth;
          canvas.height = videoHeight;
        });
        //播放视频
        video.play();
      }

      //异常的回调函数
      function error(error){
        _this.messageNotice('error',"Failed to access user media device:" + error.message);
      }
      if (navigator.mediaDevices.getUserMedia || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia){
        //调用用户媒体设备，访问摄像头
        getUserMedia({
          video:{width:1920,height:1080}
        },success,error);
      } else {
        _this.messageNotice('error',"Your browser does not support accessing user media devices");
      }
    },
     // 复制 FR photo 
    copyImgProPhoto:function(){
      let frp=_this.userInfo.profilePhotoBase64;
      _this.userInfo.faceFileBase64=frp;
      _this.$set(_this.userInfo,"faceFlag",false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/components/fastRegistration/uploadUserFace.js